import { css } from '@emotion/core'
import styled from '@emotion/styled'
import {MQ, white} from '@css/constants'
import { FontNormal } from '@css/fonts'

export const TimeRemainingWrapper = styled('div')(css`
  background: rgba(18, 142, 232, 0.4);
  border-radius: 17px;
  box-sizing: border-box;
  padding: 3px 16px;

  ${MQ.SMALL_SCREENS} {
    min-width: unset;
    width: 140px;
  }
`)

export const TimeSlot = styled('span')(css`
  ${FontNormal(600)};
  font-size: 16px;
  color: ${white};
  margin-right: 4px;

  &:last-child {
    margin-right: 0;
  }
`)
